import React from 'react';
import './HomeScreen.css';

const HomeScreen = () => {
  return (
    <div className="home-screen">
      <h1>Home Screen</h1>
      <p>Welcome to your dashboard!</p>
    </div>
  );
};

export default HomeScreen;